import { render } from "./UpdateTemplatePanel.vue?vue&type=template&id=7ef8816e&scoped=true"
import script from "./UpdateTemplatePanel.vue?vue&type=script&lang=js"
export * from "./UpdateTemplatePanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef8816e"]])

export default __exports__